import request from '../request'
// 获取在线简历
export const getOnlineCv = (cvAccountTokne) => {
	return request({
		url: `/v3/cv_accounts/${ cvAccountTokne }/online_cv`,
		method: 'get'
	})
}
// 更新在线简历
export const updateOnlineCv = (cvToken) => {
	return request({
		url: `/v3/cvs/${ cvToken }/online_cv`,
		method: 'put'
	})
}
// 创建在线简历
export const createdOnlineCv = data => {
	return request({
		url: `/v3/online_cvs`,
		method: 'post',
		data
	})
}
// 检查简历完整度
export const checkCv = (cvToken, params) => {
	return request({
		url: `/v3/cvs/${ cvToken }/complete_infos`,
		method: 'get',
		params
	})
}
// 获取用户基本信息
export const getBasicInfo = (cvAccountTokne, params) => {
	return request({
		url: `/v3/cv_accounts/${ cvAccountTokne }/basic_info`,
		method: 'get',
		params
	})
}
// 完善基本信息
export const setBasicInfo = (cvAccountTokne, data) => {
	return request({
		url: `/v3/cv_accounts/${ cvAccountTokne }/basic_info`,
		method: 'put',
		data
	})
}
// 获取用户身份
// export const getUserStatus = (params) => {
// 	return request({
// 		url: `/v1/user_status`,
// 		method: 'get',
// 		params
// 	})
// }
// 更新基本信息
export const setIdentifyInfo = (cvAccountTokne, data) => {
	return request({
		url: `/v3/cv_accounts/${ cvAccountTokne }/identify_info`,
		method: 'put',
		data
	})
}
export const getIdentifyInfo = (cvAccountTokne, data) => {
	return request({
		url: `/v3/cv_accounts/${ cvAccountTokne }/identify_info`,
		method: 'get',
		data
	})
}
// 获取验证码
export const phoneValidateCode = (cvAccountTokne, params) => {
	return request({
		url: `/v3/cv_accounts/${ cvAccountTokne }/phone_validate_code`,
		method: 'get',
		params
	})
}
// 验证手机
export const validateCode = (cvAccountTokne, data) => {
	return request({
		url: `/v3/cv_accounts/${ cvAccountTokne }/phone_validate_code`,
		method: 'post',
		data
	})
}
// 私密度
export const cvVisibility = (cvAccountTokne, params) => {
	return request({
		url: `/v3/cv_accounts/${ cvAccountTokne }/cv_visibility`,
		method: 'get',
		params
	})
}
export const setCvVisibility = (cvAccountTokne, data) => {
	return request({
		url: `/v3/cv_accounts/${ cvAccountTokne }/cv_visibility`,
		method: 'put',
		data
	})
}
// export const membershipOrder = (cvAccountTokne, data) => {
// 	return request({
// 		url: `/v2/improved_orders/membership_order`,
// 		method: 'post',
// 		data
// 	})
// }

// export const cvMiniprogramQr = (params) => {
// 	return request({
// 		url: `/v2/miniprograms/cv_miniprogram_qr`,
// 		method: 'get',
// 		params
// 	})
// }
//
// export const editableCv = (data) => {
// 	return request({
// 		url: `/v1/editable_cv`,
// 		method: 'post',
// 		data
// 	})
// }

// cvs页面推荐职位
export const cvsJobsRecommend = (params) => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/hr-api' : process.env.HR_ROOT) + `/v1/jobs/cvs_jobs_recommend`,
		method: 'get',
		params
	})
}

// cveditor下载推荐职位
export const cvsDownloadJobsRecommend = (params) => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/hr-api' : process.env.HR_ROOT) + `/v1/jobs/cv_to_job`,
		method: 'get',
		params
	})
}

// 职位页面推荐公司
export const jobsPageCompany = (params) => {
	return request({
		url: `/v3/companies`,
		method: 'get',
		params
	})
}

// 获取最后一段教育经历的毕业时间
export const getLastEducationTime = (cvAccountTokne) => {
	return request({
		url: `/v3/cv_accounts/${cvAccountTokne}/last_edu`,
		method: 'get'
	})
}

// 获取校招开关状态
export const getCampusStatus = params => {
  return request({
    url: `/v3/settings_config/message?config_name=comp_recruit`,
		method: 'get',
    params
  })
}
